import {BACKEND_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

export function findPatientByQuery(userId, query) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/user/findPatientByQuery`, query, {
            params: {userId},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
